import React from 'react';

import '/components/producer-teaser/components/producer-teaser.scss';

const ProducerTeaser = ({ producer, onMouseEnter, onMouseLeave }) => (
    <a
        className={`producer-teaser theme--${producer.theme}`}
        href={producer.url}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
    >
        {producer.image && (
            <div className="producer-teaser__image">
                <img
                    src={`${producer.image}?auto=format,compress&w=420&dpr=1&q=80`}
                    srcSet={`
                        ${producer.image}?auto=format,compress&w=420&dpr=1&q=80 420w,
                        ${producer.image}?auto=format,compress&w=420&dpr=2&q=60 840w,
                        ${producer.image}?auto=format,compress&w=420&dpr=3&q=40 1260w,
                    `}
                    sizes="420px"
                    loading="lazy"
                    alt={producer.title}
                />
            </div>
        )}
        <div className="producer-teaser__content">
            <div className="producer-teaser__title">{producer.title}</div>
            <div className="producer-teaser__address">
                {producer.address.street} {producer.address.number} {producer.address.box}<br />
                {producer.address.postalCode} {producer.address.city}
            </div>
            {producer.products.length > 0 && (
                <div className="producer-teaser__categories">
                    {producer.products.length > 8 && (
                        <React.Fragment>
                            {producer.products.slice(0, 7).map((product) => (
                                <div className="producer-teaser__category" key={product.title}>
                                    <svg viewBox="0 0 40 28">
                                        <title>{product.title}</title>
                                        <use xlinkHref={`#${product.icon}`} />
                                    </svg>
                                </div>
                            ))}
                            <div className="producer-teaser__category">
                                <svg viewBox="0 0 40 28">
                                    <title>Meer</title>
                                    <use xlinkHref="#category-more" />
                                </svg>
                            </div>
                        </React.Fragment>
                    )}
                    {producer.products.length <= 8 && (
                        <React.Fragment>
                            {producer.products.map((product) => (
                                <div className="producer-teaser__category" key={product.title}>
                                    <svg viewBox="0 0 40 28">
                                        <title>{product.title}</title>
                                        <use xlinkHref={`#${product.icon}`} />
                                    </svg>
                                </div>
                            ))}
                        </React.Fragment>
                    )}
                </div>
            )}
        </div>
    </a>
);

export { ProducerTeaser };
